import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaFilePdf, FaRegImage } from "react-icons/fa";



import { get } from "react-hook-form";
import ViewImgAndPdf from "./ViewImageAndPdf";
import { Button } from "reactstrap";
import { Icon } from "../../components/Component";
import Required from "../../MyComp/UI/form/Required";
import { handleImgPdfChange, ValidateImageAndPdf, ValidateImageOnly } from "./UtilsComponent/Utils";
 
const ImageUpload = ({
  watch,
  register,
  profile,
  errors,
  trigger,
  setValue,
  setError,
  clearErrors,
  handleImageOpenPreview,
  label,
  image,
  image_url,
  design,
  required,
  validateDoc,
}) => {
  const error = get(errors, image);
  const [modalImages, setModalImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [titleName, setTitleName] = useState("");
  const [fileTypePreview, setFileTypePreview] = useState("");
  const handleRemoveImage = (errorInput, url) => {
    setValue(errorInput, "");
    setValue(url, null);
    setValue(`${image}_type`, ""); // Clear MIME type too
    const fileInput = document.getElementById(errorInput);
    if (fileInput) {
      fileInput.value = null;
    }
  };
  const handleFileValidation = (e) => {
    const file = e.target.files[0];
    if (!file) return;
 
    const validateFn = validateDoc ? ValidateImageAndPdf : ValidateImageOnly;
 
    console.log("fucntion", validateFn, validateDoc);
 
    validateFn(file, (isValid) => {
      if (!isValid) {
        setError(image, {
          type: "manual",
          message: validateDoc ? "Only PNG, JPEG or PDF files are allowed" : "Only PNG or JPEG image files are allowed",
        });
        e.target.value = null;
        setValue(image, "");
      } else {
        clearErrors(image);
        setValue(`${image}_type`, file.type); // MIME type
        handleImgPdfChange(e, image, image_url, setValue, setError, trigger, clearErrors);
      }
    });
  };
 
  // const handleFileValidation = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;
 
  //   if (validateDoc) {
  //     ValidateImgPdf(file, (isValid) => {
  //       if (!isValid) {
  //         setError(image, {
  //           type: "manual",
  //           message: "Only PNG, JPEG or PDF files are allowed",
  //         });
  //         e.target.value = null;
  //         setValue(image, "");
  //       } else {
  //         clearErrors(image);
  //         setValue(`${image}_type`, file.type); // Store MIME type
  //         handleImageChange(e, image, image_url, setValue, setError, trigger, clearErrors);
  //       }
  //     });
  //   } else {
  //     setValue(`${image}_type`, file.type); // Store MIME type
  //     handleImageChange(e, image, image_url, setValue, setError, trigger, clearErrors);
  //   }
  // };
  const toggleImageModal = () => {
    setModalOpen(true);
  };
  const toggleModal = () => {
    setModalOpen((prev) => !prev);
  };
  const imageUrl = watch(image_url);
  const fileType = watch(`${image}_type`);
  const isPdfFile = fileType === "application/pdf";
  const shouldShowInput = imageUrl == null || error;
 
  const handleImageClick = (index, image, inputName, fileType) => {
    setCurrentImageIndex(index);
    // Replace label with "Document 1" for keys like document_0_img
    const displayTitle = /^document_\d+_img$/.test(inputName)
      ? `Document ${parseInt(inputName.match(/\d+/)?.[0] || "0", 10) + 1}`
      : inputName;
 
    setTitleName(displayTitle);
    setFileTypePreview(fileType);
 
    if (fileType === "application/pdf") {
      if (image instanceof File || image instanceof Blob) {
        setModalImages([URL.createObjectURL(image)]);
      } else {
        // if it's a string or already a URL
        setModalImages([image]);
      }
    } else {
      setModalImages([image]);
    }
 
    toggleModal();
  };
 
  const ColProps = design === false ? { md: "6", sm: "12", xxl: "2" } : { md: "3", sm: "3", xxl: "2" };
 
  return (
    <>
      <div className="form-group my-2">
        {imageUrl == null ? (
          <label className="form-label" htmlFor={image}>
            {label} {required && label && <Required />}
          </label>
        ) : null}
        {shouldShowInput && (
          <input
            type="file"
            accept="image/*,application/pdf"
            className={`form-control w-100 ${error ? "is-invalid" : ""}`}
            id={image}
            {...register(image, {
              required:
                required && !imageUrl
                  ? {
                      value: true,
                      message: label ? `${label} is required` : "Image is required",
                    }
                  : false,
            })}
            onChange={handleFileValidation}
            placeholder={"Upload"}
          />
        )}
        {error && <span className="invalid">{error?.message}</span>}
      </div>
 
      <div className="col-md-3">
        {imageUrl && !profile && (
          <>
            <span className="mx-2" onClick={() => handleRemoveImage(image, image_url)} style={{ cursor: "pointer" }}>
              x
            </span>
 
            {isPdfFile ? (
              <Button
                outline
                id="img"
                color="danger"
                type="button"
                onClick={() => handleImageClick(0, watch(image), label || image, fileType)}
                size="sm"
                data-toggle="tooltip"
                data-placement="top"
                title="View PDF"
              >
                <Icon name="file-pdf" />
              </Button>
            ) : (
              <img
                src={watch(image_url)}
                alt={image}
                style={{
                  maxWidth: "80px",
                  maxHeight: "80px",
                  marginLeft: "20px",
                  objectFit: "cover",
                }}
                onClick={() => handleImageClick(0, watch(image_url), label || image, fileType)}
              />
            )}
          </>
        )}
      </div>
 
      <ViewImgAndPdf
        fileType={fileTypePreview}
        titleName={titleName}
        isOpen={modalOpen}
        toggleModal={toggleModal}
        images={modalImages}
        currentImageIndex={currentImageIndex}
        setCurrentImageIndex={setCurrentImageIndex}
        docUploadView={true}
      />
    </>
  );
};
 
export default ImageUpload;
 